class PageFilterButtons {
    constructor(containerId) {
        this.containerId = containerId;
        this.$filterButtonsContainer = jQuery(`.mad-filter-buttons__container[data-pages-id='${this.containerId}']`);
        this.$filterButtons = this.$filterButtonsContainer.find('.mad-filter-buttons .filter-button');
        this.$pageContainer   = jQuery(`.mad-pages__container[data-pages-id='${this.containerId}'] .mad-pages`);

        this.init();
    }

    init() {
        // Attach event listeners to filter buttons
        this.$filterButtons.on('click', (event) => {
            const filterValue = jQuery(event.currentTarget).data('filter');
            this.applyFilter(filterValue);
        });
    }

    /**
     * Selects a button, filters the items, and (unless skipped) writes the
     * chosen filter to the URL so the page state can be bookmarked or shared.
     */
    applyFilter(filterValue, skipUrlUpdate = false) {
        const $button = this.$filterButtons.filter(`[data-filter='${filterValue}']`);

        // Ignore unknown filter values for this container
        if (!$button.length) {
            return;
        }

        // Change active button
        this.$filterButtons.removeClass('active');
        $button.addClass('active');

        // Show/hide items
        this.filterItems(filterValue);

        // Add/remove ?filter=… in the current URL
        if (!skipUrlUpdate) {
            this.updateUrlParam(filterValue);
        }
    }

    updateUrlParam(filterValue) {
        const url = new URL(window.location);
        if (filterValue === 'all') {
            url.searchParams.delete('filter');
        } else {
            url.searchParams.set('filter', filterValue);
        }
        // Replace state so the browser history isn’t polluted with every click
        window.history.replaceState({}, '', url);
    }

    filterItems(filterValue) {
        const $items = this.$pageContainer.find('.mad-pages__page-container');

        if (filterValue === 'all') {
            $items.removeClass('disabled');
        } else {
            $items.addClass('disabled');
            $items.filter(function () {
                const keywords = jQuery(this).data('keywords').split(' ');
                return keywords.includes(filterValue);
            }).removeClass('disabled');
        }
    }
}

jQuery(document).ready(function () {
    // Read ?filter=… from the URL (e.g. ?filter=packtisch-de)
    const urlParams    = new URLSearchParams(window.location.search);
    const initialFilter = urlParams.get('filter');

    // Initialise every filter‑button group on the page
    jQuery('.mad-filter-buttons__container').each(function () {
        const containerId       = jQuery(this).data('pages-id');
        const pageFilterButtons = new PageFilterButtons(containerId);

        // If a matching button exists in this container, trigger it on load
        if (initialFilter) {
            pageFilterButtons.applyFilter(initialFilter, true);
        }
    });
});
